type Result = {
  title: string
}

export default function generateSectionHeader(
  title?: string
): Result | undefined {
  return title
    ? {
        title
      }
    : undefined
}
